declare const jQuery: any;
const $ = jQuery;

import { each, find, map } from "lodash";

export function setCookie(name: string, value?: string, days?: number, path?: string): void
{
	let expires = "";
	if (days)
	{
		const date = new Date();
		date.setTime(date.getTime() + (days * 86400000));
		expires = "; expires=" + date.toUTCString();
	}
	window.document.cookie = name + "=" + (value || "") + expires + "; path=" + (path || "/");
}

export function getCookie(name: string): string|undefined
{
	const nameEq = name + "=";
	const ca: string[] = map(window.document.cookie.split(";"), (c: string) => c.trim());
	const cookieString: string|undefined = find(ca, (c: string) => c.indexOf(nameEq) === 0);
	if (!cookieString)
	{
		return undefined;
	}
	return cookieString.substring(nameEq.length);
}

export function deleteCookie(name: string, path?: string): void
{
	window.document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + (path || "/");
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].cookies = {
	setCookie, getCookie, deleteCookie
};
